export function parseAndRound(str, decimals) {
  if (typeof str !== String) str = str.toString();
  if (!decimals) decimals = 0;
  const value = parseFloat(str.replace(/,/g, "."));
  if (str) return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
}

export function firstCapital(str) {
  if (str) return str.charAt(0).toUpperCase() + str.slice(1);
  return str;
}

export default { parseAndRound, firstCapital };
